import { ONBOARDING_TABLE_CLASS_NAME, DEFAULT_TABLE_CLASS_NAME, ONBOARDING_LAST_TABLE_CELL_CLASS_NAME } from '../../constants/table';

const defaultFingoTable = () => ({
  borderCollapse: 'separate',
  borderSpacing: '0 10px',
  marginTop: -10,
});

const onboardingFingoTable = () => ({
  borderCollapse: 'separate',
  borderSpacing: '0 24px',
  marginTop: -24,
  [`& .${ONBOARDING_LAST_TABLE_CELL_CLASS_NAME}`]: {
    paddingRight: 16,
  },
});

const MuiTable = {
  styleOverrides: {
    root: () => ({
      [`&.${DEFAULT_TABLE_CLASS_NAME}`]: defaultFingoTable(),
      [`&.${ONBOARDING_TABLE_CLASS_NAME}`]: onboardingFingoTable(),
    }),
  },
};

export default MuiTable;
